import { PbsAdUnit } from '@pubstack/common/src/pbs/adunit'
import { adUnitSourceOfMedia, Site, SiteActivationFlags } from '@pubstack/common/src/site'
import { useAdUnits as usePbsAdUnits } from '~/api/pbs/ad-units.api'

/**
 * All a stack screen needs of an ad unit: an id to store on the configuration, and a name to show.
 */
export type StackInventoryAdUnit = Pick<PbsAdUnit, 'id' | 'name'>

/**
 * The one inventory a media's Prebid Server stack is built from — `adUnitSourceOfMedia`, as a hook.
 *
 * The same answer the backend build uses, so a screen cannot offer or resolve against an ad unit the
 * generated config will never carry: a Node media gets the single env it runs on. Listing more than one env
 * is what used to put two ad units of the same name side by side with nothing on the row to tell them apart.
 * A One media gets none, because a Node stack bound to it builds no ad units.
 *
 * Gated on the media rather than on its `env`, which the oldest ones do not carry: they read as web
 * everywhere else, and used to get an empty list here.
 */
export const useStackInventory = (site: (SiteActivationFlags & Pick<Site, 'env'>) | undefined): { adUnits: StackInventoryAdUnit[]; isLoading: boolean } => {
  const source = site ? adUnitSourceOfMedia(site) : undefined

  const { data: nodeAdUnits, isLoading } = usePbsAdUnits({ ...(source?.product === 'pbs' ? { env: [source.env] } : {}), enabled: true }, source?.product === 'pbs')

  return { adUnits: nodeAdUnits, isLoading }
}
